import qs from 'qs'

export default ({ app, router, Vue }) => {
  Vue.prototype.$qs = qs
}
